import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { plants } from "@/lib/api";
import Result from "@/pages/Result";

// Reuse Result UI by passing the scan via location state
export default function PlantDetail() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [scan, setScan] = useState(state?.scan || null);

  useEffect(() => {
    if (scan) return;
    (async () => {
      try {
        const { data } = await plants.get(id);
        // Preserve any {from} marker so Result's back button still routes correctly
        // when the user hard-refreshes or deep-links into a plant.
        navigate(".", { replace: true, state: { scan: data, from: state?.from } });
        setScan(data);
      } catch {
        navigate("/gallery", { replace: true });
      }
    })();
  }, [id, scan, navigate, state?.from]);

  return <Result />;
}
